import React from 'react'

// @material-ui/icons
import Email from '@material-ui/icons/Email'
import Close from '@material-ui/icons/Close'
// @material-ui/core components
import InputAdornment from '@material-ui/core/InputAdornment'
import Slide from '@material-ui/core/Slide'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import CustomButton from 'components/CustomButtons/Button.jsx'
import Button from '@material-ui/core/Button';
import CustomInput from 'components/CustomInput/CustomInput.jsx'
import CircularLoadingButton from 'views/Components/CircularLoadingButton'

import { renderSnackbar } from 'actions/snackbar'
import { connect } from 'react-redux'

import notificationsStyle from 'assets/jss/material-dashboard-pro-react/views/notificationsStyle.jsx'

import validate, { constraints } from 'services/formValidator'
import api from 'api'

import { withStyles } from '@material-ui/core'
import style from 'assets/css/style.jsx';

const styles = require(`../../assets/css/style.jsx`).default;

function Transition(props) {
  return <Slide direction='down' {...props} />
}

const forgot_pwd_constraints = {
  email: [constraints.isRequired, constraints.isEmail]
}

class RequestPwdForm extends React.Component {
  state = {
    email: '',
    open_request_pwd: false,
    errors: {},
    loading: false
  }

  handleForgotPwd = () => {
    const errors = validate(this.state, forgot_pwd_constraints)
    this.setState({ errors })
    if (Object.keys(errors).length === 0) {
      this.setState({ loading: true })
      api.auth.forgot_pwd({email: this.state.email})
        .then(resp => {
          this.handleClose()
          this.props.renderSnackbar({
            color: 'success',
            message: 'Un lien vous a été envoyé à l\'adresse email renseignée lors de la création de votre compte. Vous pourrez, en cliquant dessus, réinitialiser votre mot de passe.'
          })
          this.setState({ loading: false })
        })
        .catch(err => {
          this.props.renderSnackbar({
            color: 'danger',
            message: 'Aucun utilisteur ne correspond à cet adresse email.'
          })
          this.setState({ loading: false })
        })
    }
  }

  onChange = e => {
    this.setState({ email: e.target.value })
  }

  handleOpen = () => {
    this.setState({ open_request_pwd: true })
  }

  handleClose = () => {
    this.setState({ open_request_pwd: false })
  }

  render() {
    const { classes } = this.props
    const { errors, open_request_pwd, loading } = this.state

    return (
      <React.Fragment>
        {/*<Button*/}
        {/*  onClick={() => this.handleOpen()}*/}
        {/*  round*/}
        {/*  >*/}
        {/*  Mot de passe oublié*/}
        {/*</Button>*/}
        <Button onClick={() => this.handleOpen()} className={classes.btnPswForget}>Mot de passe oublié ?</Button>
        <Dialog
          classes={{
            root: classes.center + ' ' + classes.modalRoot,
            paper: classes.modal
          }}
          open={open_request_pwd}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => this.handleClose()}
          aria-labelledby='forgot-pwd-modal-slide-title'
          aria-describedby='forgot-pwd-modal-slide-description'
        >
          <DialogTitle id='forgot-pwd-modal-slide-title' disableTypography className={classes.modalHeader} >
            <p style={styles.modalTitle}>Mot de passe oublié ?</p>
            <IconButton aria-label="close" style={styles.closeButtonModal} onClick={() => this.handleClose()}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent id='forgot-pwd-modal-slide-description' className={classes.modalBody} >
            <CustomInput
              id='email'
              error={!!errors.email}
              helpText={errors.email}
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                placeholder: 'Adresse e-mail*',
                name: 'email',
                onChange: this.onChange,
                startAdornment: (
                  <InputAdornment position='start' className={classes.inputAdornment}>
                    <Email className={classes.inputAdornmentIcon} />
                  </InputAdornment>
                )
              }}
            />
          </DialogContent>
          <DialogActions className={classes.modalFooter}>
            <CustomButton  style={styles.btnModalTransp} onClick={() => this.handleClose()} >Annuler</CustomButton>
            <CustomButton  style={styles.btnModalBlack} onClick={() => this.handleForgotPwd()} >Envoyer</CustomButton>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    )
  }
}

export default connect(null, { renderSnackbar })(withStyles(notificationsStyle, style)(RequestPwdForm))



// WEBPACK FOOTER //
// ./src/views/Forms/RequestPwdForm.jsx